import { BJ2SeatBet } from '@/models/games/blackjack2/enums/BetType';
import { getTableBetByHostId } from '@/modules/betTable/slice';
import { getMainUserState } from '@/modules/main/selector';
import { bj2SeatSliceActions } from '@/modules/rwdGame/blackjack2/slice/seatSlice';
import store from '@/store/store';
import { ExchangeBetAmount } from '@/utils/commonFunc';
import { Dispatch } from 'react';
import { batch } from 'react-redux';
import { Action } from 'redux';
import { CMDSpNewBlackjackSeatInfo, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';

export class CMDSpNewBlackjackSeatInfoHandler extends AbstractHandler {
    _command: CMDSpNewBlackjackSeatInfo;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDSpNewBlackjackSeatInfo;
    }
    override handle(dispatch: Dispatch<Action>): void {
        const state = store.getState();
        const { PlayerID, ExchangeRate } = getMainUserState(state);
        batch(() => {
            this._command.SeatInfo.forEach(info => {
                const common = {
                    hostId: this._command.HostID,
                    seat: info.SeatNum,
                    PlayerID: info.PlayerID,
                    PlayerName: info.PlayerName,
                    WinningCount: info.ConsecutiveWins,
                    IsMe: info.PlayerID == PlayerID,
                    IsInsurance: info.IsInsurance == 1,
                    IsSurrender: info.IsSurrender == 1,
                };
                if (info.PlayerID == PlayerID) {
                    let seatBets = 0;
                    if (info.BetAmt > 0) {
                        const tb = state
                            ? getTableBetByHostId(state, this._command.HostID)
                            : undefined;
                        const PendingBets = tb
                            ? tb.isBetConfirmed
                                ? tb.ConfirmedBets
                                : tb.BetsSummary
                            : [];

                        PendingBets.forEach((v, i) => {
                            if (
                                v &&
                                BJ2SeatBet.indexOf(i) >= 0 &&
                                i % 10 == info.SeatNum
                            ) {
                                seatBets += v;
                            }
                        });
                    }
                    dispatch(
                        bj2SeatSliceActions.updateSeatObject({
                            ...common,
                            SeatBet: seatBets,
                            CanLeave: true,
                        })
                    );
                } else {
                    let amt =
                        ExchangeBetAmount(info.BetAmt, ExchangeRate) / 100;
                    //Fune Tune Exchange Rate Currency
                    if (
                        Math.round(amt / 100) * 100 ==
                            Math.round(amt / 10) * 10 &&
                        Math.round(amt / 10) * 10 != 0
                    ) {
                        amt = Math.round(amt / 10) * 10;
                    }
                    dispatch(
                        bj2SeatSliceActions.updateSeatObject({
                            ...common,
                            SeatBet: amt,
                            CanLeave: false,
                        })
                    );
                }
            });
        });
    }
}
